import { Fragment, useEffect } from "react"

import { useDispatch } from "react-redux"

import { getMaxCreateSteps } from "../../../User/redux/user.thunks"
import OnboardingStepItem from "../OnboardingStepItem"
import StepSectionHeader from "../StepSectionHeader"
import useBusinessStepsBlock from "./hooks/useBusinessStepsBlock"

import "../../styles.less"

const BusinessStepsBlock = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getMaxCreateSteps())
  }, [])

  const { preparedSteps, handleContinue, completedBusinessStep, stepsLoading } =
    useBusinessStepsBlock()
  return (
    <>
      {preparedSteps.map((s) => (
        <Fragment key={s.step}>
          {s.id === 1 && (
            <StepSectionHeader
              title="Getting started"
              completed={completedBusinessStep}
              total={preparedSteps.length}
            />
          )}
          <OnboardingStepItem
            id={s.id}
            step={s.step}
            title={s.title}
            description={s.description}
            handleContinue={handleContinue}
            isVerify={s.isEdit}
            isEdit={s.isEdit}
            isDivider={s.isDivider}
            isComlete={s.isCompleted}
            isContinue={s.isContinue}
            isDisabledContinue={stepsLoading}
          />
        </Fragment>
      ))}
    </>
  )
}

export default BusinessStepsBlock
